import { call, put } from 'redux-saga/effects';
import WizardServices from '@services/wizard/wizardServices';
import { setWizardVolumeSystemAction } from '../actions';

export function* fetchWizardVolumeSystemWorkerSaga() {
  try {
    const res = yield call(WizardServices.getVolumeSystems);
    yield put(setWizardVolumeSystemAction({ payload: res.data }));
  } catch (e) {
    console.error(
      `Failed to fetchWizardVolumeSystemWorkerSaga: ${e.toString()}`
    );
  }
}
